module.exports = __webpack_public_path__ + "static/media/probeta.3653b9a0.jpg";